import { sendGet } from "./generic"

const placeholder = ".json"

export const getSimpleObject = (object) => {
    return sendGet(object + placeholder)
}
